import { IMPERSONATING_KEY } from '@/consts/const';

export const IMPERSONATING_FLAG = '1';

export function setImpersonatingFlag(): void {
  localStorage.setItem(IMPERSONATING_KEY, IMPERSONATING_FLAG);
}

export function clearImpersonatingFlag(): void {
  localStorage.removeItem(IMPERSONATING_KEY);
}
